var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"previewer"}},[_c('div',{attrs:{"id":"main_viewer"},domProps:{"innerHTML":_vm._s(_vm.htmldoc)}})])}
var staticRenderFns = []

export { render, staticRenderFns }